import { ReactElement, useRef } from 'react';
import { MATERIAL_VIEWS } from '../../../../constants/search';
import CardContext from './contexts/favorites-material-card-context';
import useAddToCartSuccess from './hooks/use-add-to-cart-success';
import useCardVisibility from './hooks/use-card-visibility';
import useFolderRemovalObserver from './hooks/use-folder-removal-observer';
import { FavoritesMaterialCardProps, FavoritesMaterialCardVariationProps } from './types';
import DesktopGridCard from './variations/desktop-grid-card/desktop-grid-card';
import DesktopListCard from './variations/desktop-list-card/desktop-list-card';
import MobileCard from './variations/mobile-card/mobile-card';

export type { FavoritesMaterialCardProps, FavoritesMaterialCardVariationProps };

const FavoritesMaterialCard = (props: FavoritesMaterialCardProps): ReactElement => {
    const { viewMode, item, onRemove, ...rest } = props;

    const isGridView = viewMode === MATERIAL_VIEWS.GRID;

    const cardRef = useRef<HTMLDivElement>(null);

    const cardVisibility = useCardVisibility();
    const onAddToCartSuccess = useAddToCartSuccess();

    useFolderRemovalObserver(item, onRemove);

    const Card = cardVisibility.isTabletOrMobile ? MobileCard : isGridView ? DesktopGridCard : DesktopListCard;

    return (
        <CardContext.Provider value={{ cardRef, onRemove }}>
            <Card
                item={item}
                shouldShowFolder={cardVisibility.shouldShowFolder}
                shouldShowAddToCart={cardVisibility.shouldShowAddToCart}
                onAddToCartSuccess={onAddToCartSuccess}
                {...rest}
            />
        </CardContext.Provider>
    );
};

export default FavoritesMaterialCard;
